import "./assets/css/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import AuthLayout from "./layouts/auth";
import AdminLayout from "./layouts/admin";
import TranslatorLayout from "./layouts/translator";
import ManagerLayout from "./layouts/manager";
import CustomerLayout from "./layouts/customer";
import RouteTracker from "./components/tracking/RouteTracker";
import { useEffect } from "react";
import { alertSelector } from "store/ui/selector";
import { useSelector } from "react-redux";
import { userSelector } from "store/user/selector";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

const ProtectedRoute = ({children}: any) => {
  const searchParams = new URLSearchParams(window.location.search);
  const login_id = searchParams.get("login_id");
  if (login_id) {
    localStorage.removeItem("access_token");
  }

  const isLoggedIn = login_id
    ? false
    : localStorage.getItem("access_token")
    ? true
    : false;

  if (!isLoggedIn && !window.location.href.includes("auth")) {
    return <Navigate to="/auth/sign-in" replace />;
  }
  return children;
}

export default function Root() {
  const alert = useSelector(alertSelector);
  const user = useSelector(userSelector);
  const roleTypeId = user?.user_role_type_id;
  const isCustomer = roleTypeId === "1" || roleTypeId === 1;

  useEffect(() => {
    if (isCustomer) return;
    if (alert && alert.message) {
      if (alert.type === "success") {
        toast.success(alert.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else if (alert.type === "error") {
        toast.error(alert.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else if (alert.type === "warning") {
        toast.warn(alert.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    }
  }, [alert, isCustomer]);

  return (
    <BrowserRouter>
      <RouteTracker />
      <Routes>
        <Route path={`/auth/*`} element={<ProtectedRoute><AuthLayout /></ProtectedRoute>} />
        <Route path={`/admin/*`} element={<ProtectedRoute><AdminLayout /></ProtectedRoute>} />
        <Route path={`/translator/*`} element={<ProtectedRoute><TranslatorLayout /></ProtectedRoute>} />
        <Route path={`/manager/*`} element={<ProtectedRoute><ManagerLayout /></ProtectedRoute>} />
        <Route path={`/customer/*`} element={<ProtectedRoute><CustomerLayout /></ProtectedRoute>} />
        <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />
      </Routes>
      <ToastContainer />
    </BrowserRouter>
  );
}
